import useDefaultLayout from './useDefaultLayout';
import useLogedInLayout from './useLogedInLayout';

export default {
  useDefaultLayout,
  useLogedInLayout,
};
